import { getDepartment } from "apis/getDepartment";
import { postDepartment } from "apis/postDepartment";
import { call, put, takeLatest } from "redux-saga/effects";
import { DEFAULT_ERROR_TEXT } from "utils/constant";
import { showError, showSuccess } from "utils/ToastUtils";
import { departmentsActions } from ".";
import { IDepartment } from "./type";

export function* getDepartmentSaga() {
  try {
    const res: IDepartment[] = yield call(getDepartment);
    yield put(departmentsActions.getDepartmentSuccess(res));
  } catch (error: any) {
    showError(error?.message || DEFAULT_ERROR_TEXT);
    yield put(departmentsActions.getDepartmentFailed(error));
  }
}

export function* postDepartmentSaga(
  action: ReturnType<typeof departmentsActions.postDepartmentStarted>
) {
  try {
    yield call(postDepartment, action.payload);
    yield put(departmentsActions.postDepartmentSuccess());
    showSuccess("Cập nhập page thành công");
  } catch (error: any) {
    showError(error?.message || DEFAULT_ERROR_TEXT);
    yield put(departmentsActions.postDepartmentFailed(error));
  }
}

export function* watchDepartmentSaga() {
  yield takeLatest(
    departmentsActions.getDepartmentStarted.type,
    getDepartmentSaga
  );
  yield takeLatest(
    departmentsActions.postDepartmentStarted.type,
    postDepartmentSaga
  );
}
